import Route from '@ember/routing/route';
import { type NewsletterRouteModel } from '../newsletter';
import { service } from '@ember/service';
import RouterService from '@ember/routing/router-service';
import FundsService from 'donor-elf-web/services/funds-service';

export default class NewsletterConnectedRoute extends Route {
  @service declare fundsService: FundsService;
  @service declare router: RouterService;

  redirect(model: NewsletterRouteModel) {
    if (model.newsletterAccount == null) {
      this.router.transitionTo('funds.fund.more.newsletter.not-connected');
    } else if (
      model.newsletterAccount!.fundId !== this.fundsService.selectedFund?.id
    ) {
      this.router.transitionTo(
        'funds.fund.more.newsletter.connected-to-other-fund',
      );
    }
  }
}
